import { SearchWidgetSkeleton, SearchWidgetSkeletonFieldInterface } from './search-widget-skeleton';

export interface DisneySearchWidgetSkeletonProps {
	isFadingOut?: boolean;
}

const disneySearchFields: SearchWidgetSkeletonFieldInterface[] = [
	{ id: 'dates', flex: 1.6, minWidth: 160 },
	{ id: 'passengers', flex: 1.4, minWidth: 150 },
];

export function DisneySearchWidgetSkeleton({ isFadingOut }: Readonly<DisneySearchWidgetSkeletonProps>): JSX.Element {
	return <SearchWidgetSkeleton testIdPrefix='disney-search.widget' fields={disneySearchFields} isFadingOut={isFadingOut} />;
}

export default DisneySearchWidgetSkeleton;
